import type { FaireRetailerEntity } from "../../entity_types/retailer";

export const r_eer7xgiweo: FaireRetailerEntity = {
  token: "r_eer7xgiweo",
  type: "retailer",
  name: "Baby & Kids Store",
  themeTokens: [
    "cozy-baby-knits-organic-wooly",
    "baby-blanket-milestone-gifts",
    "first-step-leather-moccs",
    "timeless-board-books-storytime",
    "scandi-hygge-kitchen-cookbooks",
    "swedish-dishcloths-eco-home-care",
    "classic-wooden-toys-build-and-play",
    "impulse-gifts-candles-cards-candy",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
